var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner11 = function SvgSpinner11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32 12H20l4.485-4.485C22.218 5.249 19.205 4 16 4S9.781 5.248 7.515 7.515 4 12.795 4 16s1.248 6.219 3.515 8.485S12.795 28 16 28s6.219-1.248 8.485-3.515q.283-.284.546-.583l3.01 2.634A15.96 15.96 0 0 1 16 32C7.163 32 0 24.837 0 16S7.163 0 16 0c4.418 0 8.418 1.791 11.313 4.687L32 0z"
  })));
};
export default SvgSpinner11;